export default __webpack_public_path__ + "static/media/community_iso_01.de3f3d12.png";